
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/show-special/greater-ny-dental-meeting",
      function () {
        return require("private-next-pages/show-special/greater-ny-dental-meeting.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/show-special/greater-ny-dental-meeting"])
      });
    }
  